module.exports = __webpack_public_path__ + "img/Ikonw.e350aa50.png";